/**
 * Format raw incident activity action strings into human-readable labels.
 * Falls back to a clean version of the raw action if no mapping matches.
 */
export const formatIncidentActivity = (action: string): string => {
  const a = action.toLowerCase().trim();

  // Status updates
  if (a === 'statusupdate' || a === 'status_update') return 'Updated status';
  if (a.includes('accounted') && !a.includes('not')) return 'Marked Accounted';
  if (a.includes('notaccounted') || a.includes('not_accounted') || a.includes('not accounted')) return 'Marked Not Accounted';
  if (a.includes('notchecked') || a.includes('not_checked') || a.includes('not checked') || a.includes('reset')) return 'Reset to Not Checked';

  // Person management
  if (a.includes('added') || a.includes('created') || a.includes('visitor')) return 'Added Person';
  if (a.includes('removed') || a.includes('deleted')) return 'Removed Person';

  // Checkpoint and incident lifecycle
  if (a.includes('checkpoint')) return 'Recorded Checkpoint';
  if (a.includes('closed') || a.includes('close')) return 'Closed Incident';
  if (a.includes('opened') || a.includes('started') || a.includes('created_incident')) return 'Opened Incident';

  // Fallback: capitalize first letter, replace underscores/camelCase
  const cleaned = action
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/_/g, ' ')
    .trim();
  if (cleaned.length === 0) return 'Updated status';
  return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
};
